

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class AccountingJournalEntry_ManagedObject

class AccountingJournalEntry_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: date
    set date(value:Date) {
        this.setValueForKey(value, 'date');
    }
    get date():Date {
        return this.valueForKey('date');
    }
    set datePrimitiveValue(value:Date) {
        this.setPrimitiveValueForKey(value, 'date');
    }
    get datePrimitiveValue():Date {
        return this.primitiveValueForKey('date');
    }

    // Property: journalIndex
    set journalIndex(value:number) {
        this.setValueForKey(value, 'journalIndex');
    }
    get journalIndex():number {
        return this.valueForKey('journalIndex');
    }
    set journalIndexPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'journalIndex');
    }
    get journalIndexPrimitiveValue():number {
        return this.primitiveValueForKey('journalIndex');
    }

    // Property: linkedEntityID
    set linkedEntityID(value:string) {
        this.setValueForKey(value, 'linkedEntityID');
    }
    get linkedEntityID():string {
        return this.valueForKey('linkedEntityID');
    }
    set linkedEntityIDPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'linkedEntityID');
    }
    get linkedEntityIDPrimitiveValue():string {
        return this.primitiveValueForKey('linkedEntityID');
    }

    // Property: linkedEntityName
    set linkedEntityName(value:string) {
        this.setValueForKey(value, 'linkedEntityName');
    }
    get linkedEntityName():string {
        return this.valueForKey('linkedEntityName');
    }
    set linkedEntityNamePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'linkedEntityName');
    }
    get linkedEntityNamePrimitiveValue():string {
        return this.primitiveValueForKey('linkedEntityName');
    }

    // Property: locked
    set locked(value:boolean) {
        this.setValueForKey(value, 'locked');
    }
    get locked():boolean {
        return this.valueForKey('locked');
    }
    set lockedPrimitiveValue(value:boolean) {
        this.setPrimitiveValueForKey(value, 'locked');
    }
    get lockedPrimitiveValue():boolean {
        return this.primitiveValueForKey('locked');
    }
    // Relationship: bankFile
    set bankFile(value:BankTransferBundleFile) {
        this.setValueForKey(value, 'bankFile');
    }
    get bankFile():BankTransferBundleFile {
        return this.valueForKey('bankFile') as BankTransferBundleFile;
    }

    // Relationship: entries
    protected _entries:MIOManagedObjectSet = null;
    get entries():MIOManagedObjectSet {
        return this.valueForKey('entries');
    }
    addEntriesObject(value:AccountingEntry) {
        this._addObjectForKey(value, 'entries');
    }
    removeEntriesObject(value:AccountingEntry) {
        this._removeObjectForKey(value, 'entries');
    }
}
